import styled from 'styled-components';
import { ButtonProps } from 'react-html-props';
// Botão vazio, com apenas um ícone svg centralizado. Uma pequena animação de hover/active.
export const IconButton = styled.button`
    display: flex;
    flex-direction: column;
    border: none;
    background: none;
    cursor: pointer;
    transition: 0.1s;
`;

export const ButtonIcon = styled.button`
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    align-items: center;
    border: none;
    background: none;
    cursor: pointer;
    transition: 0.2s;

    svg {
        width: 1.5rem;
        height: 1.5rem;
    }

    padding: 0.71875rem 0.75rem;
    border-radius: 0.75rem;
    color: var(--Neutral-800, #27272a);
    font-size: 1rem;
    font-weight: 600;
    line-height: normal;

    &.yellow {
        color: var(--Neutral-800, #27272a);
        background: #ffcf00;
        --hover-color: #ffd724;
    }

    &.blue {
        color: #ffffff;
        font-weight: 600;
        svg path {
            stroke: #ffffff;
        }
        background: #008cff;
        --hover-color: #0178da;

        svg {
            /* width: 1rem;
            height: 1rem; */
        }
    }

    &.green {
        color: #ffffff;
        font-weight: 600;
        background: #16a34a;
        --hover-color: #15803d;
    }

    &.empty {
        padding: 0;
        width: 1.25rem;
        height: 1.25rem;

        &.red {
            color: #E11D48;
        }
    }

    &.round {
        border-radius: 1.875rem;
    }

    &:hover {
        transform: scale(1.04);
    }

    &:active {
        transform: scale(0.97);
    }

    &:hover {
        background-color: var(--hover-color);
    }
`;

type VariantsType = 'yellow' | 'blue' | 'green' | 'round' | 'empty' | 'red';

interface VariantProps {
    variant: VariantsType | VariantsType[];
}

export const ButtonWithIcon = (props: VariantProps & ButtonProps) => {
    const variantClassname = Array.isArray(props.variant)
        ? props.variant.join(' ')
        : props.variant;
    return (
        <ButtonIcon
            {...props}
            className={(props.className ?? '') + ' ' + variantClassname}
        />
    );
};
